import React from 'react';
import { fx } from '../../fx.js';
import { useTheme } from '../../hooks.js';
import { ink } from '../../primitives.js';
import { applyTheme } from '../../theme.js';

const h = React.createElement;

/**
 * Light/dark switch. Click wipes the new theme out from the toggle (View Transition); whisper,
 * reduced motion or no support: a fade. Reads and writes html[data-theme].
 *
 * @param {object} p
 * @param {number} [p.size]
 * @param {boolean} [p.bare]
 * @param {string} [p.title]
 */
export function ThemeToggle({ size = 30, bare, title = 'Switch theme' }) {
  const theme = useTheme(), dark = theme === 'dark', ref = React.useRef(null);
  const W = size * 1.8, K = size - 8;
  /* click = the wipe from the toggle (no hold: a hold reads as lag). Whisper and reduced motion: a quick fade. */
  const click = () => { const f = fx; applyTheme(dark ? 'light' : 'dark', { wipe: f.quirk ? f.quirk() !== 'whisper' : true, from: ref.current }); };
  return h('button', {
    ref, type: 'button', title, 'aria-label': 'Toggle theme', 'aria-pressed': dark, onClick: click,
    style: { position: 'relative', width: W, height: size, padding: 0, border: bare ? '2px solid transparent' : ink(2), borderRadius: 20, background: bare ? 'transparent' : 'var(--card)', boxShadow: bare ? 'none' : 'var(--el-1)', cursor: 'pointer', boxSizing: 'border-box' }
  }, h('span', {
    style: { position: 'absolute', top: 2, left: 2, width: K, height: K, borderRadius: '50%', border: ink(1.5), boxSizing: 'border-box', overflow: 'hidden', background: dark ? `linear-gradient(90deg, var(--bg) 50%, var(--inkbg) 50%)` : 'var(--gold)', transform: dark ? `translateX(${W - K - 8}px) rotate(180deg)` : 'translateX(0) rotate(0)', transition: 'transform var(--dur-base) var(--ease-pop), background var(--dur-fast)' }
  }));
}
